module.exports = __webpack_public_path__ + "static/media/galerija_2014 (14).36f55894.jpg";